import React, { lazy } from 'react';
var AKSectionMessage = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/section-message');
});
export var APPEARANCE_OLD_TO_NEW_MAPPING = {
  info: 'information',
  confirmation: 'success',
  change: 'discovery',
  warning: 'warning',
  error: 'error'
};
var SectionMessage = function SectionMessage(_ref) {
  var title = _ref.title,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'info' : _ref$appearance,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AKSectionMessage, {
    title: title
    //TODO: Remove this mapping once the forge-ui package is updated to accomodate section-message appearance changes
    ,
    appearance: APPEARANCE_OLD_TO_NEW_MAPPING[appearance]
  }, children);
};
export default SectionMessage;
export var SectionMessageFn = function SectionMessageFn(_ref2) {
  var props = _ref2.props,
    children = _ref2.children,
    Components = _ref2.Components,
    render = _ref2.render,
    renderChildren = _ref2.renderChildren,
    dispatch = _ref2.dispatch;
  var _ref3 = props,
    title = _ref3.title,
    appearance = _ref3.appearance;
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: title,
    appearance: appearance
  }, renderChildren({
    Components: Components,
    children: children,
    render: render,
    dispatch: dispatch
  }));
};